<template>
  <div
    id="modal-global"
    class="modalGlobal scrollbar xl:container xl:mx-auto relative"
    :class="showModal ? 'block' : 'hidden'"
  >
    <!-- Modal -->
    <div class="fixed inset-0 flex justify-center items-center">
      <div
        class="fixed inset-0 bg-gray-900 bg-opacity-50"
        @click="closeModal"
      ></div>
      <div
        class="overflow-y-auto w-full md:w-4/5 mx-1 md:m-auto search-custom-scrollbar rounded-lg"
      >
        <form
          ref="searchForm"
          name="searchForm"
          method="get"
          class="flex flex-col form-search-page relative bg-white rounded-lg"
          @submit.prevent="submitSearch"
        >
          <!-- Botón de cierre -->
          <div class="w-full md:w-4/5 m-auto fixed flex justify-end">
            <button
              type="button"
              class="mt-3 mr-6 md:mt-7 md:mr-10 z-50 text-2xl h-8 w-8 rounded-full bg-gray-700 text-white cursor-pointer"
              @click="closeModal()"
            >
              &times;
            </button>
          </div>

          <div class="bg-custom-search px-4 py-8 md:p-13 rounded-lg">
            <div class="search-custom-size">
              <h1 class="search-title-ai" v-html="allText.title"></h1>

              <div class="search-box-ai">
                <div class="relative w-full search-box-ai-content">
                  <input
                    type="text"
                    :placeholder="
                      allText.placeholder
                        | replaceLabel(localData.design.labels)
                    "
                    name="filters[keyword]"
                    v-model="localData.applied_filters.keyword"
                    ref="input"
                    :disabled="isSearchingIA"
                    @keydown.enter.prevent="onKeyEnter"
                  />
                  <button
                    class="input-button"
                    type="submit"
                    :disabled="
                      isSearchingIA ||
                      isSearching ||
                      localData.applied_filters.keyword.length < 3
                    "
                  >
                    <span>
                      {{
                        isSearchingIA
                          ? allText.searchingWithAi
                          : allText.searchWithAi
                      }}
                    </span>
                    <i
                      class="w-5 h-5 fill-none flex-none transition-transform"
                      :class="{ 'animate-magic-wand': isSearchingIA }"
                      v-icon:search-bar-ia
                    ></i>
                  </button>
                </div>

                <button
                  class="mobile-button"
                  type="submit"
                  data-testid="submit-search"
                  :disabled="
                    isSearchingIA ||
                    isSearching ||
                    localData.applied_filters.keyword.length < 3
                  "
                >
                  <span>
                    {{
                      isSearchingIA
                        ? allText.searchingWithAi
                        : allText.searchWithAi
                    }}
                  </span>
                  <i
                    class="w-5 h-5 fill-none flex-none transition-transform"
                    :class="{ 'animate-magic-wand': isSearchingIA }"
                    v-icon:search-bar-ia
                  ></i>
                </button>
              </div>

              <div
                v-if="questions.length && !hasDataAi && !isSearchingIA"
                class="text-center mb-4 -mt-2"
              >
                <div
                  class="flex flex-col md:flex-row gap-3 md:gap-6 justify-center"
                >
                  <button
                    type="button"
                    @click="openQuestion(item)"
                    data-testid="query-button-search"
                    class="w-full py-2 px-4 bg-white bg-opacity-10 hover:bg-opacity-20 rounded-lg shadow-lg backdrop-blur-sm md:w-60 xl:w-64 cursor-pointer transition-colors duration-500"
                    v-for="(item, index) in questions"
                    :key="index"
                  >
                    <p class="text-geb-aquamarineAlt text-sm text-center">
                      {{ item }}
                    </p>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="search-content-ai search-custom-size-body"
              v-if="(hasDataAi || isSearchingIA) && !hasErrorAI"
            >
              <div
                class="search-content-ai-body bg-white bg-opacity-20 p-3 md:p-10 rounded-lg"
              >
                <template v-if="isSearchingIA">
                  <div
                    class="search-content-ai-body-left animate-pulse mb-6 md:mb-0"
                  >
                    <span class="text-xs text-geb-aquamarine uppercase">{{
                      allText.searching
                    }}</span>
                    <div class="section">
                      <div class="h-7 rounded-lg bg-white bg-opacity-40"></div>
                      <p
                        class="mt-2 rounded-lg bg-white bg-opacity-40 h-17"
                      ></p>
                    </div>
                  </div>

                  <div class="search-content-ai-body-right animate-pulse">
                    <span class="text-xs text-geb-aquamarine">{{
                      allText.sources
                    }}</span>
                    <div class="section">
                      <ul class="space-y-2">
                        <li
                          class="flex h-6 bg-white bg-opacity-40 rounded-lg"
                        ></li>
                        <li
                          class="flex h-6 bg-white bg-opacity-40 rounded-lg"
                        ></li>
                        <li
                          class="flex h-6 bg-white bg-opacity-40 rounded-lg"
                        ></li>
                      </ul>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="search-content-ai-body-left mb-6 md:mb-0">
                    <span class="text-xs text-geb-aquamarine uppercase">{{
                      allText.response
                    }}</span>
                    <div class="section">
                      <h3
                        class="text-xl font-semibold flex items-center gap-2"
                        v-if="hasDataAi && dataAI.ai.title"
                        data-testid="result-search-title"
                      >
                        {{ dataAI.ai.title }}
                      </h3>
                      <p
                        data-testid="result-search-content"
                        ref="typedText"
                        class="flex flex-col gap-3 my-2 text-sm max-h-48 overflow-auto custom-scroll"
                      ></p>
                      <!-- <button
                        type="button"
                        class="text-geb-aquamarine text-xs mt-2 inline-block"
                        @click="toggleTypedTextShow"
                        v-if="showViewMore"
                      >
                        {{
                          showTypedTextShow
                            ? allText.viewLessToSee
                            : allText.viewMore
                        }}
                      </button> -->
                    </div>
                  </div>

                  <div
                    v-if="hasDataAi && dataAI.ai.references.length"
                    class="search-content-ai-body-right"
                  >
                    <span class="text-xs text-geb-aquamarine">{{
                      allText.sources
                    }}</span>
                    <div class="section">
                      <ul class="space-y-2">
                        <li
                          v-for="(item, index) in dataAI.ai.references"
                          :key="index"
                        >
                          <a
                            @click.prevent="
                              onReferenceClick(item.url, item.title)
                            "
                            :title="item.title"
                            class="text-xs font-semibold flex items-center gap-x-2"
                          >
                            <i
                              class="w-6 h-6 text-blue-600 fill-none flex-none"
                              v-icon:search-report
                            ></i>
                            <span class="line-clamp-2">{{ item.title }}</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <div
              v-if="hasErrorAI"
              class="bg-white bg-opacity-20 p-3 md:p-6 rounded-lg"
            >
              <p class="text-sm text-white">{{ errorMessageAI }}</p>
            </div>

            <div class="search-content-ai-disclaimer" v-if="allText.disclaimer">
              <p class="text-xs text-white text-center mt-8">
                {{ allText.disclaimer }}
              </p>
            </div>
          </div>

          <div
            class="search-custom-size-body px-4 sm:px-6 md:px-13"
            v-if="!isSearching"
          >
            <template v-if="hasItems">
              <div class="flex justify-between mb-7 mt-8">
                <p class="text-sm">
                  {{ localData.pager.total }}
                  {{
                    allText.resultCount | replaceLabel(localData.design.labels)
                  }}
                </p>
              </div>

              <div class="flex gap-y-6 flex-col mb-6">
                <p v-if="titleArticles" class="font-semibold text-2xl">
                  {{ titleArticles }}
                </p>
                <ul class="space-y-8" data-testid="result-search-list">
                  <li
                    class="bg-white cursor-pointer text-geb-gray-700 hover:text-geb-green-700"
                    v-for="(item, index) in localData.items"
                    :key="index"
                  >
                    <a
                      @click.prevent="
                        onLinkClick(item.link, item.title, index + 1)
                      "
                      class="flex gap-3 flex-nowrap"
                    >
                      <span
                        class="w-6 h-6 mt-0.5 fill-none flex-shrink-0"
                        v-icon:[getLinkIcon(item)]
                      ></span>
                      <div>
                        <h3 class="font-semibold text-lg sm:text-xl mb-1.5">
                          {{ item.title }}
                        </h3>
                        <div
                          class="flex justify-between items-start gap-10"
                          v-if="item.resume"
                        >
                          <p
                            class="text-sm leading-relaxed line-clamp-3"
                            v-html="item.resume.trim()"
                          ></p>
                        </div>
                        <div class="flex items-center gap-1" v-if="isPDF(item)">
                          <span class="text-sm leading-relaxed">{{
                            allText.download
                          }}</span>
                          <span
                            class="w-4 h-4 fill-none flex-shrink-0"
                            v-icon:tw-download
                          ></span>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>

                <div class="flex justify-center md:justify-end">
                  <button
                    data-testid="result-search-viewmore"
                    type="button"
                    @click="onLinkClickTrad(urlRedirect)"
                    class="flex items-center gap-4 bg-geb-green-secondary hover:bg-geb-green-800 text-white rounded-3sm transition-all duration-500 py-4 px-10 uppercase text-xs leading-6 font-medium tracking-2widest"
                  >
                    <span> {{ allText.allResults }}</span>
                    <span class="w-4 h-4" v-icon:arrow-right-link-alt></span>
                  </button>
                </div>
              </div>
            </template>
            <template v-else-if="hasError">
              <div class="flex justify-center my-4">
                <p>
                  {{ errorMessage }}
                </p>
              </div>
            </template>
            <template
              v-else-if="
                !hasItems && !hasError && !isFirstSearch && !isSearching
              "
            >
              <div class="flex justify-center my-4">
                <p>
                  {{ allText.noResultsMessage }}
                </p>
              </div>
            </template>
          </div>

          <input type="hidden" name="recaptcha_token" :value="recaptchaToken" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from "../../utils/markdown.esm.js";
import throttle from "lodash.throttle";
import Typed from "typed.js";

import {
  dispatchSearchClickGAEvent,
  dispatchSearchAIClickGAEvent,
  dispatchSearchResultGAEvent,
  dispatchSearchAIResultGAEvent,
} from "../../utils/index.js";
import { generateRecaptchaToken } from "../../utils/recaptcha.js";
import { EventBus } from "../../EventBus.js";

export default {
  name: "SearchAiModal",
  props: {
    allText: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    apiUrl: {
      type: String,
      default: "",
    },
    apiIaUrl: {
      type: String,
      default: "",
    },
    recaptchaEnabled: {
      type: Boolean,
      default: false,
    },
    recaptchaPublicKey: {
      type: String,
      default: "",
    },
    questions: {
      type: Array,
      default: () => [],
    },
    urlRedirect: {
      type: String,
      default: "#",
    },
    titleArticles: {
      type: String,
      default: "Noticias artículos e informes",
    },
    timeoutAi: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      isFirstSearch: true,
      isSearching: false,
      isSearchingIA: false,
      recaptchaToken: "",
      localData: JSON.parse(JSON.stringify(this.data)),
      dataAI: null,
      showModal: false,
      typed: null,
      timer: null,
      timerAi: null,
      controllerReCaptcha: null,
      controllerReCaptchaAi: null,
      controllerSearch: null,
      controllerSearchAi: null,
      showTypedTextShow: false,
      showViewMore: false,
      hasError: false,
      hasErrorAI: false,
      errorMessage: "",
      errorMessageAI: "",
      throttledCheckClamp: null,
    };
  },
  filters: {
    replaceLabel(value, labelsMap) {
      // return labelsMap[value.toLowerCase()] ?? value;
      return value;
    },
  },
  computed: {
    hasItems() {
      return this.localData?.items?.length > 0;
    },
    dataAggregations() {
      const asArray = Object.entries(this.localData.aggregations || {});
      const filtered = asArray.filter(([key, value]) => !!value);
      return Object.fromEntries(filtered);
    },
    hasDataAi() {
      return this.dataAI?.ai;
    },
  },
  watch: {
    showModal(newValue) {
      if (!newValue) {
        clearTimeout(this.timer);
        clearTimeout(this.timerAi);
        this.controllerReCaptcha?.abort();
        this.controllerReCaptchaAi?.abort();
        this.controllerSearch?.abort();
        this.controllerSearchAi?.abort();
        this.localData = JSON.parse(JSON.stringify(this.data));
        this.dataAI = null;
        this.showViewMore = false;
        this.showTypedTextShow = false;
        this.isFirstSearch = true;
        this.hasError = false;
        this.hasErrorAI = false;
        this.errorMessage = "";
        this.errorMessageAI = "";
      }
    },
  },
  methods: {
    isPDF(item) {
      return item.type?.toLowerCase() === "archivo geb";
    },
    getLinkIcon(item) {
      return this.isPDF(item) ? "download-file" : "article";
    },
    setShowViewMore() {
      this.$nextTick(() => {
        const paragraph = this.$refs.typedText;
        const clon = paragraph?.cloneNode(true);
        if (clon) {
          clon.style.display = "block";
          clon.style.position = "absolute";
          clon.style.visibility = "hidden";
          clon.style.maxHeight = "none";
          clon.style.webkitLineClamp = "unset";
          clon.style.width = `${paragraph.clientWidth}px`;
          clon.innerText = this.escapeHtml(this.dataAI.ai.response);
          document.body.appendChild(clon);

          const lineHeight = parseFloat(getComputedStyle(clon).lineHeight);
          const maxHeight = lineHeight * 5;

          this.showViewMore = clon.clientHeight > maxHeight;

          document.body.removeChild(clon);
        }
      });
    },
    async getRecaptchaToken() {
      const recaptchaToken = await generateRecaptchaToken(
        this.recaptchaEnabled,
        this.recaptchaPublicKey,
        this.controllerReCaptcha.signal
      );
      this.recaptchaToken = recaptchaToken;
      return recaptchaToken;
    },
    async searchGeneral() {
      try {
        this.hasError = false;
        this.isSearching = true;
        const recaptchaToken = await this.getRecaptchaToken();
        const form = this.$refs.searchForm;
        const formData = new FormData(form);

        formData.set(
          "filters[keyword]",
          this.localData.applied_filters.keyword ?? ""
        );
        formData.set("recaptcha_token", recaptchaToken);

        const updatedData = [...formData.entries()];
        const formString = updatedData
          .map((x) => `${x[0]}=${encodeURIComponent(x[1])}`)
          .join("&");

        this.controllerSearch = new AbortController();

        const response = await fetch(`${this.apiUrl}?${formString}`, {
          signal: this.controllerSearch.signal,
        });
        const responseJson = await response.json();

        if (responseJson.status === 500) {
          throw new Error(`Error: ${responseJson.message}`);
        } else {
          this.localData = responseJson;
        }

        dispatchSearchResultGAEvent(
          "general",
          this.localData.applied_filters?.keyword ?? "",
          this.hasItems
        );
      } catch (error) {
        this.hasError = true;
        if (error.name !== "AbortError") {
          if (navigator.onLine) {
            this.errorMessage = this.allText.errorMessage;
            throw new Error(
              "Hubo un error al realizar la búsqueda, inténtalo nuevamente."
            );
          } else {
            this.errorMessage = this.allText.offlineMessage;
            throw new Error(
              "Error, verifica tu conexión y vuelve a intentarlo."
            );
          }
        }
      } finally {
        this.isSearching = false;
      }
    },
    async searchAi() {
      try {
        this.isSearchingIA = true;
        this.hasErrorAI = false;
        const recaptchaToken = await this.getRecaptchaToken();

        const form = this.$refs.searchForm;
        const formData = new FormData(form);

        formData.set(
          "filters[keyword]",
          this.localData.applied_filters?.keyword
        );
        formData.set("recaptcha_token", recaptchaToken);

        const updatedData = [...formData.entries()];
        const formString = updatedData
          .map((x) => `${x[0]}=${encodeURIComponent(x[1])}`)
          .join("&");

        this.controllerSearchAi = new AbortController();
        const timeoutSignal = AbortSignal.timeout(this.timeoutAi);

        const response = await fetch(`${this.apiIaUrl}?${formString}`, {
          signal: AbortSignal.any([
            this.controllerSearchAi.signal,
            timeoutSignal,
          ]),
        });

        const responseJson = await response.json();
        let newTypedText = null;

        if (responseJson.status === 500) {
          this.dataAI = null;
          throw new Error(`Error: ${responseJson.message}`);
        } else {
          if (responseJson.ai.statusCode === 500) {
            this.errorMessageAI = this.allText.errorMessage;
            throw new Error(this.allText.errorMessage);
          }

          this.dataAI = responseJson;

          newTypedText =
            responseJson.ai.statusCode === 204
              ? this.allText.genericIA
              : this.dataAI.ai.response;

          dispatchSearchAIResultGAEvent(
            "general",
            this.localData.applied_filters?.keyword ?? "",
            this.dataAI.ai.statusCode === 200 && !!this.dataAI.ai.response
          );
        }

        if (newTypedText) {
          this.timer = setTimeout(() => {
            this.typed = new Typed(this.$refs.typedText, {
              strings: [this.parseMarkdown(this.escapeHtml(newTypedText))],
              typeSpeed: 1,
              showCursor: false,
            });
            this.setShowViewMore();
          }, 500);
        }
      } catch (error) {
        this.hasErrorAI = true;
        if (error.name !== "AbortError") {
          if (navigator.onLine) {
            if (error.name === "TimeoutError") {
              this.errorMessageAI = this.allText.timeoutAiMessage;
              throw new Error(error);
            } else {
              this.errorMessageAI = this.allText.errorMessage;
              throw new Error(
                "Hubo un error al realizar la búsqueda con IA, inténtalo nuevamente."
              );
            }
          } else {
            throw new Error(
              "Error, verifica tu conexión y vuelve a intentarlo."
            );
          }
        }
      } finally {
        this.isSearchingIA = false;
      }
    },
    submitSearch() {
      if (this.isSearching || this.isSearchingIA) return;
      clearTimeout(this.timer);
      this.isFirstSearch = false;

      this.showViewMore = false;
      this.showTypedTextShow = false;
      this.controllerReCaptcha = new AbortController();
      this.controllerReCaptchaAi = new AbortController();

      this.searchAi().catch((error) => console.error(error));
      this.searchGeneral().catch((error) => console.error(error));
    },
    onReferenceClick(link, title) {
      dispatchSearchAIClickGAEvent(
        "general",
        this.localData.applied_filters.keyword ?? "",
        title,
        link
      );
      window.location.href = link;
    },
    async onLinkClick(link, title, index) {
      dispatchSearchClickGAEvent(
        "general",
        this.localData.applied_filters.keyword ?? "",
        index + (this.localData.pager.current_page - 1) * 10,
        title
      );
      window.location.href = link;
    },
    async onLinkClickTrad(link) {
      const recaptchaToken = await this.getRecaptchaToken();

      const searchParams = new URLSearchParams({
        "filters[keyword]": this.localData.applied_filters.keyword,
        recaptcha_token: recaptchaToken,
      });
      window.location.href = `${link}?${searchParams.toString()}`;
    },
    async getUpdatedPageLink(page) {
      const recaptchaToken = await this.getRecaptchaToken();

      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("page", page);
      searchParams.set("recaptcha_token", recaptchaToken);

      window.location.href = `${
        window.location.pathname
      }?${searchParams.toString()}`;
    },
    closeModal() {
      this.showModal = false;
      this.localData.applied_filters.keyword = "";
    },
    getStringTruncated(value) {
      const shortText = value.split(/\s+/).slice(0, 4).join(" ");
      return value.length > shortText.length ? `${shortText}...` : shortText;
    },
    async onKeyEnter() {
      if (this.showModal && this.localData.applied_filters.keyword.length > 2) {
        await this.submitSearch();
      }
    },
    async openQuestion(text) {
      if (this.showModal) {
        this.localData.applied_filters.keyword = text;
        this.focusInput();
        this.$refs.input?.select();
      }
    },
    escapeHtml(text) {
      const map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      };
      return text.replace(/[&<>"']/g, (m) => map[m]);
    },
    focusInput() {
      requestAnimationFrame(() => {
        this.$refs.input?.focus();
      });
    },
    toggleTypedTextShow() {
      this.showTypedTextShow = !this.showTypedTextShow;
    },
    onKeyDownHandler(event) {
      if (this.showModal && (event.key === "Escape" || event.keyCode === 27)) {
        this.closeModal();
      }
    },
    parseMarkdown(str) {
      return marked.parse(str);
    },
  },
  mounted() {
    EventBus.$on("toggleModalGlobal", (value) => {
      this.showModal = value;
      if (value) {
        this.focusInput();
      } else {
        this.closeModal();
      }
    });

    this.throttledCheckClamp = throttle(this.setShowViewMore, 200);
    window.addEventListener("resize", this.throttledCheckClamp);
    window.addEventListener("keydown", this.onKeyDownHandler);
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeyDownHandler);
    if (this.throttledCheckClamp) {
      window.removeEventListener("resize", this.throttledCheckClamp);
    }
  },
};
</script>
<style>
.typed-element {
  white-space: pre;
}

@keyframes magicWand {
  0% {
    transform: rotate(0deg) scale(1);
  }
  20% {
    transform: rotate(-15deg) scale(1.1);
  }
  40% {
    transform: rotate(15deg) scale(1.1);
  }
  60% {
    transform: rotate(-10deg) scale(1.05);
  }
  80% {
    transform: rotate(10deg) scale(1.05);
  }
  100% {
    transform: rotate(0deg) scale(1);
  }
}

.animate-magic-wand {
  animation: magicWand 1s ease-in-out infinite;
}
</style>
